import { getService } from "./service";
import { setCircularLoading } from "./UiReducer";
// import { notify } from "./NotifierReducer";
import { handleError } from "./ErrorReducer";
import { serviceNames } from "../utils/constants";

// Initial State for User Settings
const initialState = {
  userSettings: [],
  loading: false,
  error: null,
};

const FETCH_USER_SETTINGS_REQUEST = "FETCH_USER_SETTINGS_REQUEST";
const FETCH_USER_SETTINGS_SUCCESS = "FETCH_USER_SETTINGS_SUCCESS";
const FETCH_USER_SETTINGS_FAILURE = "FETCH_USER_SETTINGS_FAILURE";
const CREATE_USER_SETTING_REQUEST = "CREATE_USER_SETTING_REQUEST";
const CREATE_USER_SETTING_SUCCESS = "CREATE_USER_SETTING_SUCCESS";
const CREATE_USER_SETTING_FAILURE = "CREATE_USER_SETTING_FAILURE";
const UPDATE_USER_SETTING_REQUEST = "UPDATE_USER_SETTING_REQUEST";
const UPDATE_USER_SETTING_SUCCESS = "UPDATE_USER_SETTING_SUCCESS";
const UPDATE_USER_SETTING_FAILURE = "UPDATE_USER_SETTING_FAILURE";

// Action creators

export const getUserSettings = (userId) => async (dispatch) => {
  dispatch({ type: FETCH_USER_SETTINGS_REQUEST });
  dispatch(setCircularLoading(true));
  try {
    const service = getService(serviceNames.userSettings);
    const result = await service.find({
      query: {
        userId: userId,
      },
    });
    dispatch({
      type: FETCH_USER_SETTINGS_SUCCESS,
      payload: result,
    });
  } catch (error) {
    dispatch({ type: FETCH_USER_SETTINGS_FAILURE, payload: error.message });
    // dispatch(
    //   notify(`Failed to fetch user settings: ${error.message}`, "error")
    // );
    dispatch(handleError(error));
  } finally {
    dispatch(setCircularLoading(false));
  }
};

export const updateOrCreateUserSetting =
  (userId, key, value) => async (dispatch) => {
    dispatch({ type: UPDATE_USER_SETTING_REQUEST });
    dispatch(setCircularLoading(true));
    try {
      const service = getService(serviceNames.userSettings);

      // Check if the setting already exists
      const existingSetting = await service.find({
        query: {
          userId,
          key,
        },
      });

      if (existingSetting && existingSetting.length > 0) {
        // Update existing setting
        const setting = existingSetting[0];
        const updatedSetting = await service.patch(setting.id, { value });
        dispatch({
          type: UPDATE_USER_SETTING_SUCCESS,
          payload: updatedSetting,
        });
        // dispatch(notify("User setting updated successfully", "success"));
      } else {
        // Create a new setting if it doesn't exist
        const newSetting = await service.create({ userId, key, value });
        dispatch({ type: CREATE_USER_SETTING_SUCCESS, payload: newSetting });
        // dispatch(notify("User setting created successfully", "success"));
      }
    } catch (error) {
      dispatch({ type: UPDATE_USER_SETTING_FAILURE, payload: error.message });
      //   dispatch(
      //     notify(
      //       `Failed to update or create user setting: ${error.message}`,
      //       "error"
      //     )
      //   );
      dispatch(handleError(error));
    } finally {
      dispatch(setCircularLoading(false));
    }
  };

// Reducer
export default function userSettingsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_USER_SETTINGS_REQUEST:
    case CREATE_USER_SETTING_REQUEST:
    case UPDATE_USER_SETTING_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_USER_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        userSettings: action.payload,
      };

    case CREATE_USER_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        userSettings: [...state.userSettings, action.payload],
      };

    case UPDATE_USER_SETTING_SUCCESS:
      return {
        ...state,
        loading: false,
        userSettings: state.userSettings.map((setting) =>
          setting.key === action.payload.key ? action.payload : setting
        ),
      };

    case FETCH_USER_SETTINGS_FAILURE:
    case CREATE_USER_SETTING_FAILURE:
    case UPDATE_USER_SETTING_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
